import React, {FC, useCallback, useState, useEffect} from "react";
import { useTask } from '../stateManagement/context';

import {
    IControlMeasure, IDocument, IFNCurve, IUpload,

} from "../types/types";

import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TableCell,
    TableRow,
    Typography
} from "@material-ui/core";
import {CloudUpload} from "@material-ui/icons";
import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";
import {post, upload} from "../fetchers/fetchers";
 
import {useParams} from "react-router";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import {Delete, Edit} from "@material-ui/icons";
import { API_URL } from "../env";

interface IRouteParams {
    id: string
}

interface IFNCurveUploadProps {
    control_measure: IControlMeasure
    fn_curve: IFNCurve
    updateFNCurve: () => void;
}


const FNCurveUpload: FC<IFNCurveUploadProps> = ({
                                                              control_measure,
                                                                fn_curve,
                                                    updateFNCurve
                                                          }) => {

    const [current_fn_curve, setFNCurve] = useState<IFNCurve>(fn_curve);
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileID, setFileID] = useState<IUpload>();
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [documentRef, setDocumentRef] = useState<IDocument>();
    const params = useParams<IRouteParams>()
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const updateDocumentSelection= useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)

    }, [setDocumentRef]);

    const uploadFile = async (file: any) => {
        const d = await upload<IUpload>( API_URL + "upload/", file);
        setFileID(d)
    }

    const handleCapture = ({ target }: any) => {
        let formData = new FormData();
        formData.append("file", target.files[0]);
        uploadFile(formData).then(() => setSelectedFile(target.files[0].name))
    };

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const postCurveUpload = async () => {
        if (fileID) {
            const d = await post<IFNCurve>( API_URL + "fn/" + params.id + "/", {
                upload_id: fileID.uuid,
                is_existing: current_fn_curve.is_existing,
                control_measure_id: current_fn_curve.control_measure_id,
                document_id: documentRef?.id
            });
        }
    }

    const postFNCurve = async (fn_curve : IFNCurve) => {
            const d = await post<IFNCurve>( API_URL + "fn/" + params.id + "/", fn_curve);
    }

    const submitAssessments = () => {
        if (fileID) {
            postCurveUpload().then(() => {
                setOpenCreateDialog(false)
                updateFNCurve()
            })
        }

    }

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }


    const handleDelete = () => {
        let fn_curve = {... current_fn_curve}
        fn_curve.is_active = false
        delete fn_curve.document
        delete fn_curve.id

        postFNCurve(fn_curve).then(() => {
            setOpenCreateDialog(false)
            updateFNCurve()
        })
    }

    const renderAreYouSure = () => {
        return(
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove FN Curve</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove FN curve <b>{control_measure.description}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const create_upload_dialog = () => {
        return (<Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Upload FN Curve</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            The csv file needs to have following headers:<br/>
                            <small>F,n</small>
                        </Typography>

                        <p/>
                        {!selectedFile  && <div>
                            <input
                                accept=".csv"
                                id="icon-button-upload"
                                type="file"
                                hidden
                                onChange={handleCapture}
                                disabled={!write_access}
                            />

                            <label htmlFor="icon-button-upload">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUpload />}
                                    onClick={() => handleOpen()}
                                >
                                    Upload
                                </Button>
                            </label>

                        </div>}
                        {selectedFile && <div>
                            {selectedFile}
                        </div>}
                        <p/>

                        <Documents updateDocumentID={updateDocumentSelection}/>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    {selectedFile && <Button onClick={submitAssessments}  color="primary">
                        Submit
                    </Button>}
                </DialogActions>
            </Dialog>
        )
    }


    return (
        <TableRow>
            <TableCell>{control_measure.description}</TableCell>
            <TableCell>
                {write_access && <>
                {current_fn_curve.upload_id &&
                <>
                    {create_upload_dialog()}
                    {renderAreYouSure()}

                    <IconButton color="primary" component="span"
                                style={{
                                    margin: "auto",
                                    color: "rgb(239,88,43)"
                                }} onClick={() => handleOpen()}>
                        <Edit />
                    </IconButton>
                    <IconButton color="primary" aria-label="upload picture" component="span"  style={{
                        color:"rgb(239,88,43)",

                    }} onClick={() => setAreYouSure(true)} >
                        <Delete />
                    </IconButton>
                </>
                    
                } 
                    
                {!current_fn_curve.upload_id &&
                <>
                    {create_upload_dialog()}
                <IconButton color="primary" component="span"
                                               style={{margin:"auto",
                                                   backgroundColor:"rgb(239,88,43)",
                                                   color:"rgb(255,255,255)"
                                               }}  onClick={() => handleOpen()}>
                <CloudUpload  fontSize="small" />
            </IconButton>
            </>}
            </> }
            </TableCell>

        </TableRow>
    );
}
export default FNCurveUpload;
